import { formatLocation } from '../ControlId.js';
const colorButtonYellow = 'rgb(255, 198, 0)';
const colorEmptyGrey = 'rgb(50, 50, 50)';
const colorBlack = 'black';
export class ButtonDecorationRenderer {
    static DEFAULT_HEIGHT = 14;
    static drawStatusBar(img, drawStyle, topBarBounds, emptyButton) {
        const drawColor = emptyButton ? colorEmptyGrey : colorButtonYellow;
        let step = '';
        img.box(topBarBounds.x, topBarBounds.y, topBarBounds.maxX, topBarBounds.maxY - 0.5, colorBlack);
        img.line(topBarBounds.x, topBarBounds.maxY - 0.5, topBarBounds.maxX, topBarBounds.maxY - 0.5, {
            color: drawColor,
            width: 1,
        });
        if (!emptyButton && drawStyle.stepCount > 1) {
            step = `.${drawStyle.stepCurrent}`;
        }
        const locationDrawX = Math.round(topBarBounds.width * 0.05) + topBarBounds.x;
        const locationDrawY = Math.round(topBarBounds.height * 0.15) + topBarBounds.y;
        const locationDrawSize = Math.round(topBarBounds.height * 0.65);
        if (drawStyle.location === undefined) {
            // Preview (no location)
            img.drawTextLine(locationDrawX, locationDrawY, `x/x/x${step}`, drawColor, locationDrawSize);
        }
        else if (drawStyle.pushed) {
            img.box(topBarBounds.x, topBarBounds.y, topBarBounds.maxX, topBarBounds.maxY, drawColor);
            img.drawTextLine(locationDrawX, locationDrawY, `${formatLocation(drawStyle.location)}${step}`, colorBlack, locationDrawSize);
        }
        else {
            img.drawTextLine(locationDrawX, locationDrawY, `${formatLocation(drawStyle.location)}${step}`, drawColor, locationDrawSize);
        }
    }
    static drawBorderWhenPushed(img, drawStyle, outerBounds) {
        if (drawStyle.pushed) {
            img.boxLine(outerBounds.x, outerBounds.y, outerBounds.maxX, outerBounds.maxY, { color: colorButtonYellow, width: 3 }, 'inside');
        }
    }
    static drawIcons(img, drawStyle, topBarBounds) {
        // const iconHeight
        let rightMax = topBarBounds.x + topBarBounds.width;
        // next error or warning icon
        const iconSize = Math.floor(topBarBounds.height * 0.65);
        const iconPadding = Math.floor(topBarBounds.height * 0.175);
        let statusColor;
        switch (drawStyle.button_status) {
            case 'error':
                statusColor = 'red';
                break;
            case 'warning':
                statusColor = 'rgb(255, 127, 0)';
                break;
        }
        if (statusColor) {
            img.drawFilledPath([
                [rightMax - (iconSize + iconPadding), topBarBounds.y + iconSize + iconPadding],
                [rightMax - iconPadding, topBarBounds.y + iconSize + iconPadding],
                [rightMax - (iconSize / 2 + iconPadding), topBarBounds.y + iconPadding],
            ], statusColor);
            img.drawTextLineAligned(rightMax - (iconSize / 2 + iconPadding), topBarBounds.y + iconSize + iconPadding, '!', colorBlack, Math.floor(iconSize * 0.7), 'center', 'bottom', 'bold');
            rightMax -= iconSize + iconPadding;
        }
        // last running icon
        if (drawStyle.action_running) {
            //img.drawTextLine(55, 3, '►', 'rgb(0, 255, 0)', 8) // not as nice
            let iconcolor = 'rgb(0, 255, 0)';
            if (drawStyle.pushed)
                iconcolor = colorBlack;
            img.drawFilledPath([
                [rightMax - iconSize, topBarBounds.y + iconPadding],
                [rightMax - iconPadding, topBarBounds.y + iconPadding + iconSize / 2],
                [rightMax - iconSize, topBarBounds.y + iconPadding + iconSize],
            ], iconcolor);
            rightMax -= iconSize;
        }
    }
}
//# sourceMappingURL=ButtonDecorationRenderer.js.map